import ApprovalDashboard from "./ApprovalDashboard"
import { useDispatch, useSelector } from "react-redux";
import { setApprovalHistoryReport, setApprovalHistoryReportFilters, setApprovalManagmentTab } from "Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction";
import { setRegionDropDown } from "Store/Organization/Region/RegionAction";
import { setMarketDropDown } from "Store/Organization/Market/MarketAction";
import { setCostCenterByBranch, setCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { setSuperRegion } from "Store/Organization/SuperRegion/SuperRegionActions";
import { setBranchDropDown } from "Store/Organization/Branch/BranchAction";
import { setApproverUpdatesGridData, setComplianceModificationReport, setComplianceReportFilterData, setComplianceReportGridData } from "Store/OrderManagement/ComplainceReport/ComplainceReportAction";
import { useEffect, useState } from "react";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { useNavigate } from "react-router-dom";
import userProfileSelectors from "../../../../redux/UserProfile/selectors";
import { setApprovalListAssignment } from "Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentAction";
import { setApprovalHierarchyBySuperRegion } from "Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyAction";
import ApprovalHierarchy from "./ApprovalHierarchy";
import ApprovalListAssignment from "./ApprovalListAssignment";
import ApprovalHistoryReport from "./ApprovalHistoryReport";
import ApprovalComplianceContainer from "./ApprovalComplainceReport/ApprovalComplainceReport-container";

const ApprovalDashboardContainer = () => {

    const [tabItem, setTabItem] = useState<any>([])

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        approvalManagementTab,
        userDetails
    } : any = useSelector((state: any) => ({
        approvalManagementTab: state?.ApprovalHistoryReportReducer?.approvalManagementTab,
        userDetails: userProfileSelectors.getUserDetails(state)
    }))

    const breadcrumlist = [
        { text: 'Approval Hierarchy', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); } }, {}
    ]

    useEffect(() => {
        if ((!isAuthorized(permissions.ViewHierarchy) && !isAuthorized(permissions.ViewApprovalHistory) && !isAuthorized(permissions.ViewComplianceReport)) && userDetails?.permissions) {
            navigate(`/ordermanagement`)
        }

        if (isAuthorized(permissions.ViewHierarchy)) {
            setTabItem([
                {
                    itemKey: "approval-hierarchy",
                    headerText: "Approval Hierarchy",
                    content: <ApprovalHierarchy />
                },
                {
                    itemKey: "approvalhistory",
                    headerText: "Approval History",
                    content: <ApprovalHistoryReport />
                },
                {
                    itemKey: "compliance-report",
                    headerText: "Compliance Report",
                    content: <ApprovalComplianceContainer />
                },
                {
                    itemKey: "approvalList-assignment",
                    headerText: "Approval List Assignment",
                    content: <ApprovalListAssignment />
                }
            ]);
        } else if (isAuthorized(permissions.ViewApprovalHistory) && !isAuthorized(permissions.ViewComplianceReport)) {
            setTabItem([
                {
                    itemKey: "approvalhistory",
                    headerText: "Approval History",
                    content: <ApprovalHistoryReport />
                }
            ]);
        } else if (isAuthorized(permissions.ViewComplianceReport) && !isAuthorized(permissions.ViewApprovalHistory)) {
            setTabItem([
                {
                    itemKey: "compliance-report",
                    headerText: "Compliance Report",
                    content: <ApprovalComplianceContainer />
                }
            ]);
        } else if (isAuthorized(permissions.ViewComplianceReport) && isAuthorized(permissions.ViewApprovalHistory)) {
            setTabItem([
                {
                    itemKey: "approvalhistory",
                    headerText: "Approval History",
                    content: <ApprovalHistoryReport />
                },
                {
                    itemKey: "compliance-report",
                    headerText: "Compliance Report",
                    content: <ApprovalComplianceContainer />
                }
            ]);
        }
    }, [userDetails?.permissions])

    const handleLinkClick = (item?: any) => {
        if (item) {
            dispatch(setApprovalManagmentTab(item?.props?.itemKey))
            dispatch(setApprovalHistoryReportFilters({}))
            dispatch(setSuperRegion([]))
            dispatch(setRegionDropDown([]))
            dispatch(setMarketDropDown([]))
            dispatch(setBranchDropDown([]))
            dispatch(setCostCenterByBranch([]))
            dispatch(setApprovalHistoryReport([]))
            dispatch(setCostCenterBySearchString([]))
            dispatch(setComplianceReportFilterData(null))
            dispatch(setComplianceModificationReport(null))
            dispatch(setComplianceReportGridData(null))
            dispatch(setApproverUpdatesGridData(null))
            dispatch(setApprovalListAssignment(null))
            dispatch(setApprovalHierarchyBySuperRegion(null))
        }
    };

    return(
        <ApprovalDashboard 
            breadcrumlist={breadcrumlist}
            approvalManagementTab={approvalManagementTab}
            handleLinkClick={handleLinkClick}    
            tabItem = {tabItem}
        />
    )
}

export default ApprovalDashboardContainer